import React, { useEffect, useRef, useMemo } from 'react';
import { observer } from 'mobx-react';
import cn from 'classnames';
import Messages from './components/Messages/Messages';
import NoMessages from './components/NoMessages';
import { useStores } from 'stores';
import styles from './ChatWindow.module.scss';

const ChatWindow = observer(() => {
  const {
    messageStore: { isLoading, messages, currentConversation },
  } = useStores();

  const chatWindowRef = useRef(null);

  // chatWindowRef is used to scroll to the end of the div conatining messages hence
  // showing the latest ones. The entire mechanism probably has to be revorked at some point,
  // to allow loading older messages as needed, but for now this is how it is.
  // If someone wishes to improve it later => now it doesn't scroll completely to the bottom,
  // there is still some scroll space being left. This is probably the limitation of the scrollIntoView().
  // Perhaps some manual adjustment could solve this, or replacing the scrollIntoView() altogehter
  // in favor of something better
  // height has to be 100%, otherwise it doesn't work

  useEffect(() => {
    if (chatWindowRef.current && !isLoading && messages.length) {
      chatWindowRef.current.scrollTo({ top: chatWindowRef.current.scrollHeight, behavior: 'smooth' });
    }
  }, [messages, isLoading]);

  const isMessages = useMemo(() => currentConversation && currentConversation !== 0, [currentConversation]);

  // tabIndex is there to allow user to scroll chat history
  return (
    <div ref={chatWindowRef} tabIndex="0" className={cn(styles['chat-window'], 'col')}>
      {isMessages ? <Messages /> : <NoMessages />}
    </div>
  );
});
export default ChatWindow;
